import script from "./CollectionCheckPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionCheckPopup.vue?vue&type=script&setup=true&lang=js"

import "./CollectionCheckPopup.vue?vue&type=style&index=0&id=01931580&lang=scss"

const __exports__ = script;

export default __exports__